import { DataLayer } from '@grandvisionhq/analytics';
import { clearEvents } from './utils.js';

const logPrescriptionDownloadEvent = ()=>{
    clearEvents();
    DataLayer.pushEvent({
        event: 'myAccount',
        events: {
            category: 'my prescriptions',
            action: {
                block: 'prescriptions',
                interaction: 'download'
            }
        }
    });
};

export { logPrescriptionDownloadEvent };
//# sourceMappingURL=prescriptions.js.map
